import { CustomChat, FacebookProvider } from "react-facebook";

const MessengerChatBot = () => {
    // return (
    //     <FacebookProvider appId="593115370384090" chatSupport>
    //         <CustomChat pageId="518037181398765" minimized={true} />
    //     </FacebookProvider>
    // );
    return null
};

export default MessengerChatBot;